/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useRef } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  tabHighLigther,
  autoFormateDate,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { ManufactureTableHead } from './TableHead';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  quarterTest1,
  quarterTest2,
  lowerCaseAllWordsExceptFirstLetters,
  upperCaseFirstLetter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

import {
  dispatchQtrRange,
  dispatchErrorMsgRates,
  dispatchPerformResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRebateProgramName,
  getManufacturerList,
  dispatchManufacturer,
  getSupplementData,
  dispatchSupplementalRates,
  dispatchDisplayObjRates,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
} from '../../../../SharedModules/Errors/constantMessageData';

import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const SupplementalRates = (props) => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,
    selectedPlanType,
    rebateProgram: getRebateProgramList,
    rebateProgramName: getRebateProgramName,
    errorMsgRates: getErrorMsg,
    startQtr: getQuarter,
    manufacturerList: resultmanufacturerList,
    isAllManufacturersSelected: isAllManufacturersSelectedValue,
    selectRowIndex: selectRowIndexValue,
    suppleRates: getSuppleRates,
  } = useSelector((state) => state?.sharedState?.SupplementalReducer);

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const dispatch = useDispatch();
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [radioList, setRadioList] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [startQtr, setStartQtr] = React.useState(getQuarter);
  const [fullScreenView, setFullScreenView] = React.useState(false);

  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [manufacturerSelected, setManufacturerSelected] = React.useState('ALL');
  const [scrollDownManufacturers, setScrollDownManufacturers] =
    React.useState(true);
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] =
    React.useState(isAllManufacturersSelectedValue);
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          startQtr: '',
        }
  );

  // dispatch function
  const setPerformScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };
  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    dispatch(dispatchErrorMsgRates([]));
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRates(unique));
  };

  const handleOnblurEvent = (type, value) => {
    dispatch(dispatchErrorMsgRates([]));
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'startQtr') {
      value = autoFormateDate(data);
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'startQtr',
              errorType: 'startQtrRequired',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'startQtr',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'startQtr');
          setStartQtr(value?.toUpperCase());
        } else {
          localErr = localErr.filter((item) => item.field !== 'startQtr');
          localErr.push({
            field: 'startQtr',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'startQtr');
        if (type === 'startQtr') {
          localErr.push({
            field: 'startQtr',
            errorType: 'startQtrRequired',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRates(unique));
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/supplementalRates', true);
    } else {
      tabHighLigther('/supplementalRates', false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultmanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultmanufacturerList]);
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);
  // on selection of row data
  const onSelectionChanged = (e) => {
    dispatch(dispatchErrorMsgRates([]));
    const selectedRows = e.api?.getSelectedRows();
    setSelectedRows(selectedRows);
    if (
      selectedRows?.length === manufacturerList.length
      // || selectedRows.length === 0
    ) {
      setManufacturerSelected('ALL');
    } else {
      const selectedManuId = [];
      for (let i = 0; i < selectedRows?.length; i++) {
        selectedManuId.push(selectedRows[i].mfgId);
      }
      selectedManuId.sort();
      setManufacturerSelected(selectedManuId);
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field !== 'nomanufacture' && item.field != "noData");
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgRates(unique));
    }
  };

  // Search button on click functionality
  const onClickOnSearch = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = []
  ) => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );

    let index = manufacturerList.findIndex(
      (obj) =>
        obj.mfgId === selectedRows[0]?.mfgId ||
        obj.mfgId === selectedRowOnDoubleClick[0]?.mfgId
    );
    index = index === -1 ? null : index;

    const sRows =
      (isAllManufacturersSelected
        ? manufacturerList
        : onDoubleClick
        ? selectedRowOnDoubleClick
        : selectedRows) || [];
    let localErr = getErrorMsg || [];
    localErr =
      localErr && localErr?.filter((item) => item.field !== 'nomanufacture');

    if (sRows.length == 0) {
      localErr.push({
        field: 'nomanufacture',
        errorType: 'manufactureRequired',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }
    if (!startQtr) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'startQtr');
      localErr.push({
        field: 'startQtr',
        errorType: 'startQtrRequired',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRates(unique));
    if (state.rebateProgramCd != '-1' && sRows.length > 0) {
      dispatch(dispatchSupplementalRates([]));
      setSearchClicked(true);

      dispatch(
        getSupplementData({
          rebateProgram: rebateProgramName?.rebateProgramCd,
          quarter: startQtr,
          mfg:
            manufacturerSelected == 'ALL'
              ? manufacturerSelected
              : onDoubleClick
              ? selectedRowOnDoubleClick[0]?.mfgId
              : manufacturerSelected[0],
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchQtrRange(startQtr));
      dispatch(
        dispatchManufacturer({
          manufacturerSelected: onDoubleClick
            ? selectedRowOnDoubleClick
            : manufacturerSelected,
          isAllManufacturersSelected,
          selectRowIndex: index,
          selectedPlanType: state.planTypeCd,
        })
      );
      dispatch(
        dispatchDisplayObjRates({
          rebateProgramName,
          startQtr,
          manufacturerSelected: onDoubleClick
            ? selectedRowOnDoubleClick
            : manufacturerSelected,
          isAllManufacturersSelected,
          selectRowIndex: index,
          selectedPlanType: state.planTypeCd,
        })
      );
    }
  };

  if (
    isSearchClicked &&
    getSuppleRates?.supplementalRatesReportVO?.length > 0
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displaySupplementalRates',
      value: 'Display Supplemental Rates',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displaySupplementalRates',
    });
    dispatch(clearReduxForFilterAndSort('/displaySupplementalRates'));
  }

  // setting Quarter From
  const handlefromChange = (event) => {
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setStartQtr(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'startQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgRates(unique));
  };

  // For No Data validation for auto Scroll
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);
          
  // remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgRates([]));
  }, [state.planTypeCd, planTypeList, state.rebateProgramCd, startQtr, isAllManufacturersSelected, scrollDownManufacturers, fullScreenView]);
  

  const cellClickedListener = (e) => {
    setSelectedRows([e?.data]);
    onClickOnSearch(null, true, [e?.data]);
  };
  const [gridApi, setGridApi] = React.useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  React.useEffect(() => {
    if (!gridApi || manufacturerList === 0) return;
    const selectedRows = gridApi.getSelectedRows();
    if (selectedRows?.length > 0) return;
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
    }
  }, [gridApi, manufacturerList]);
  return (
    <div
      className="tabs-container  tBillPanel custom-check"
      data-testid="program-and-eligibility"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="State Reports" parent2="Supplemental Rates" />
      {/* <div id="errorScroll"> */}
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          }
        />
      ) : null}
      {/* </div> */}

      <div className="row">
        <div className="col-4 frr-two-col-radio">
          <RadioGroupComponent
            data-testid="radio-button-for-rcdd"
            id="radio-button-for-rcdd_id"
            labelName="Plan Type"
            required
            optionList={radioList || []}
            defaultValue={state && state.planTypeCd}
            filterAction={(e) => {
              handleOnChangeEvent(e, 'planTypeCd');
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>
        <div className="col-4 frr-two-col-radio ">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Rebate Program<span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper p-3">
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  name="rebateProgram"
                  id="rebate_program"
                  label="Rebate Program"
                  data-testid="Supplemental-Rates-Rebate-Program"
                  fullWidth
                  select
                  required
                  inputProps={{ maxLength: 11, id: 'rebate_program' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd'
                            ? 'mandate-fields'
                            : null
                        )
                      : null
                  }
                  onBlur={(e) =>
                    handleOnblurEvent('rebateProgramCd', e.target.value)
                  }
                  onChange={(e) =>
                    handleOnChangeEvent(e?.target?.value, 'rebateProgramCd')
                  }
                  value={
                    state && state.rebateProgramCd ? state.rebateProgramCd : ''
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                >
                  <MenuItem
                    key=""
                    value="-1"
                    className="frr-dropdown-blank-item"
                  />
                  {rebateProgramList &&
                  rebateProgramList.length &&
                  rebateProgramList.length > 0
                    ? rebateProgramList.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-4 frr-two-col-radio">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Quarter<span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper p-3">
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  id="check_by_invoice_quater"
                  label="check_by_invoice_quater"
                  data-testid="Supplements-Rates-Qtr"
                  required
                  fullWidth
                  value={startQtr}
                  onChange={handlefromChange}
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="startQtr"
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'startQtr' ? 'mandate-fields' : null
                        )
                      : null
                  }
                  onBlur={(e) => handleOnblurEvent('startQtr', e.target.value)}
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'startQtr' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'startQtr' ? l.message : null
                        )
                      : null
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="col-4" style={{ marginTop: '30px' }}>
        <FormControlLabel
          control={
            <Checkbox
              data-testid="supplement-Rates-allManufacturers"
              checked={isAllManufacturersSelected}
              color="primary"
              name="allManufacturers"
              onChange={async (e) => {
                setIsAllManufacturersSelected(!isAllManufacturersSelected);
                setScrollDownManufacturers(!scrollDownManufacturers);
                if (!isAllManufacturersSelected) {
                  setManufacturerSelected('ALL');
                } else {
                  setManufacturerSelected([]);
                }
                const elem = document.getElementById('abc11');
                if (elem && scrollDownManufacturers) {
                  await Promise.resolve();
                  // setTimeout(() => {
                    elem.scrollIntoView();
                  // }, 1000);
                }
                let localErr = getErrorMsg || [];
                localErr = localErr.filter(
                  (item) => item.field !== 'nomanufacture'
                );
                const unique = [...new Set(localErr)];
                dispatch(dispatchErrorMsgRates(unique));
              }}
            />
          }
          label="All Manufacturers"
        />
      </div>
      <div className="col-12 btn-wrapper mb-2">
        <div className="float-right mt-2 hide-on-print">
          <Button
            className="btn btn-success btn-search"
            data-testid="view_detail_ia"
            type="button"
            onClick={onClickOnSearch}
          >
            {' '}
            <SVGComponent iconName="Icon-search" /> {'  '} Search
          </Button>
        </div>
      </div>
      <br />
      <br />

      <div className="row" id="abc11">
        {!isAllManufacturersSelected && (
          <div className="col-12 unallocated">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              helpMessage
              gridCall={onGridReady}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={ManufactureTableHead}
              rowData={manufacturerList}
              cellClickedListener={cellClickedListener}
              selectRowIndex={selectRowIndexValue}
              rowSelection="single"
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fileName="Manufacturer List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name.substring(0, 30)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SupplementalRates;
